import { createFileRoute, redirect } from '@tanstack/react-router'
import { AccountingSettingsScreen } from '@/features/accounting-settings/settings-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/settings')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_settings.edit')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: AccountingSettingsScreen,
})
